module.exports = __webpack_public_path__ + "img/Next2.85b27848.svg";